export const GET_DAILY_INVOICE_TRACKING_REQUEST = "GET_DAILY_INVOICE_TRACKING_REQUEST";
export const GET_DAILY_INVOICE_TRACKING_SUCCESS = "GET_DAILY_INVOICE_TRACKING_SUCCESS";
export const GET_DAILY_INVOICE_TRACKING_FAIL = "GET_DAILY_INVOICE_TRACKING_FAIL";

